import React from 'react';
import { Grid, Box } from '@material-ui/core';
import '../css-components/Card.css';

const Card = (props) => {
  const { children, style, className } = props;

  return (
    <Box className={`card ${className}`} style={style}>
      <Grid style={{ borderRadius: '8px' }} container>
        {children}
      </Grid>
    </Box>
  );
};

export default Card;
